module.exports = __webpack_public_path__ + "models/extender_e4abf5a298c102e62477df36c4f96651.glb";